import { Component, Input, OnInit } from '@angular/core';
import { SettingsRoute } from './../../../constants/settings-routes.constant';

@Component({
  selector: 'settings-header',
  template: require('./settings-header.component.html'),
  styles: [require('./settings-header.component.scss')],
})
export class SettingsHeaderComponent implements OnInit {
  @Input() currentRoute: SettingsRoute;

  constructor() {
    // empty block
  }

  ngOnInit() {
    // empty block
  }
}
